import { MirrorService } from 'services/MirrorService';

import { ReactComponent as AdventureDateLogo } from 'assets/logos/adventuredate.svg';
import { ReactComponent as AdventureDateDarkLogo } from 'assets/logos/adventuredate-dark.svg';
import { ReactComponent as BestHookuperLogo } from 'assets/logos/besthookuper.svg';
import { ReactComponent as BestHookuperDarkLogo } from 'assets/logos/besthookuper-dark.svg';
import { ReactComponent as DatesMeLogo } from 'assets/logos/dates-me.svg';
import { ReactComponent as DatesMeDarkLogo } from 'assets/logos/dates-me-dark.svg';
import { ReactComponent as HookupersLogo } from 'assets/logos/hookupers.svg';
import { ReactComponent as HookupersDarkLogo } from 'assets/logos/hookupers-dark.svg';
import { ReactComponent as HookupParadiseLogo } from 'assets/logos/hookupparadise.svg';
import { ReactComponent as HookupParadiseDarkLogo } from 'assets/logos/hookupparadise-dark.svg';
import { ReactComponent as JustLovebirdsLogo } from 'assets/logos/justlovebirds.svg';
import { ReactComponent as JustLovebirdsDarkLogo } from 'assets/logos/justlovebirds-dark.svg';
import { ReactComponent as LocalsDateLogo } from 'assets/logos/locals-date-dark.svg';
import { ReactComponent as LocalsjoyLogo } from 'assets/logos/localsjoy.svg';
import { ReactComponent as LocalsjoyDarkLogo } from 'assets/logos/localsjoy-dark.svg';
import { ReactComponent as LustStationLogo } from 'assets/logos/lust-station.svg';
import { ReactComponent as LustStationDarkLogo } from 'assets/logos/lust-station-dark.svg';
import { ReactComponent as MePlusYouLogo } from 'assets/logos/meplusyou.svg';
import { ReactComponent as MePlusYouDarkLogo } from 'assets/logos/meplusyou-dark.svg';
import { ReactComponent as SimpleDatesCoLogo } from 'assets/logos/simple-dates-co.svg';
import { ReactComponent as SimpleDatesCoDarkLogo } from 'assets/logos/simple-dates-co-dark.svg';
import { ReactComponent as SimpleDatesMeLogo } from 'assets/logos/simple-dates-me.svg';
import { ReactComponent as SimpleDatesMeDarkLogo } from 'assets/logos/simple-dates-me-dark.svg';

export const getCurrentLogo = ({ isDark }: { isDark: boolean }) => {
  if (MirrorService.isHookupers) {
    return isDark ? HookupersDarkLogo : HookupersLogo;
  }
  if (MirrorService.isBestHookuper) {
    return isDark ? BestHookuperDarkLogo : BestHookuperLogo;
  }
  if (MirrorService.isHookupParadise) {
    return isDark ? HookupParadiseDarkLogo : HookupParadiseLogo;
  }
  if (MirrorService.isDatesMe) {
    return isDark ? DatesMeDarkLogo : DatesMeLogo;
  }
  if (MirrorService.isSimpleDatesMe) {
    return isDark ? SimpleDatesMeDarkLogo : SimpleDatesMeLogo;
  }
  if (MirrorService.isMePlusYou) {
    return isDark ? MePlusYouDarkLogo : MePlusYouLogo;
  }

  if (MirrorService.isLocalsDate) {
    return LocalsDateLogo;
  }
  if (MirrorService.isLustStation) {
    return isDark ? LustStationDarkLogo : LustStationLogo;
  }
  if (MirrorService.isLocalsJoy) {
    return isDark ? LocalsjoyLogo : LocalsjoyDarkLogo;
  }

  if (MirrorService.isSimpleDatesCo) {
    return isDark ? SimpleDatesCoDarkLogo : SimpleDatesCoLogo;
  }
  if (MirrorService.isJustLovebirds) {
    return isDark ? JustLovebirdsDarkLogo : JustLovebirdsLogo;
  }
  if (MirrorService.isAdventureDate) {
    return isDark ? AdventureDateDarkLogo : AdventureDateLogo;
  }

  return null;
};
